<template>
  <div class="summary-metric-rows">
    <div v-for="row in rows" :key="row.key" class="summary-metric-rows__row">
      <template v-for="column in row.columns">
        <ProgramMetric
          v-if="column.componentType"
          :key="column.key"
          :component-type="column.componentType"
          :metric="column.metric"
          :is-earnings="column.isEarnings"
          :is-dollar-budget="isDollarBudget"
          :basis="basis"
          class="summary-metric-rows__column"
        />
        <!-- Unconfigured slot: holds its width so the metrics beside it stay put. -->
        <div
          v-else
          :key="column.key + '-spacer'"
          class="summary-metric-rows__column"
          aria-hidden="true"
        />
      </template>
    </div>
    <div v-if="metricsMissing" class="summary-metric-rows__message">
      <Typography variant="body-1" as="span"
        >Metrics have not been calculated yet for this program.</Typography
      >
    </div>
    <div v-if="loadFailed">
      <Typography variant="body-1" as="span"
        >We couldn't load your progress right now. Please try again later.</Typography
      >
    </div>
  </div>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import ProgramMetric from "./metrics/ProgramMetric.vue";

export default {
  name: "SummaryMetricRows",
  components: { Typography, ProgramMetric },
  props: {
    // [{ key, columns: [{ key, componentType, metric, isEarnings }] }] — the shape
    // toParticipantMetricRows() produces. Shared by the summary card and the detail
    // page; a column with no componentType renders as an empty spacer.
    rows: { type: Array, default: () => [] },
    isDollarBudget: { type: Boolean, default: false },
    basis: { type: String, default: null },
    metricsMissing: { type: Boolean, default: false },
    loadFailed: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.summary-metric-rows {
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
}

.summary-metric-rows__row {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
}

.summary-metric-rows__column {
  flex: 1 1 0;
  min-width: 0;
}

.summary-metric-rows__message {
  text-align: left;
}
</style>
